import { BaseModel, Attribute } from './base-model'

export class PlayHistory extends BaseModel {
  public id: number
  public position: number
  public playbackRate: number
  public playing: boolean
  public seeking: boolean
  public nativeSeeking: boolean
  public jumping: boolean
  public jumppedKind: string
  public skipping: boolean
  public skippedDuration: number
  @Attribute(Date)    public date: Date
  public userId: number
  public videoId: number
  public sessionId: string
  public segment: string
  public windowInnerWidth: number
  public windowInnerHeight: number
}



// WEBPACK FOOTER //
// ./src/models/play-history.ts